import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';

import { AppState } from '../../models/communication/app-state.model';

/**
 * Facilitates development by showing (toggling)
 * the current app state by pressing `toggleKey`.
 */
@Component({
    selector: 'app-dev',
    imports: [CommonModule],
    templateUrl: './dev.component.html',
    styleUrl: './dev.component.scss'
})
export class DevComponent implements OnInit, OnDestroy {
    @Input()
    state?: AppState;

    @Input()
    toggleKey?: string;

    protected demoModeEnabled = false;
    private sub?: Subscription;

    ngOnInit(): void {
        const key = this.toggleKey ?? 'd';
        this.sub = fromEvent<KeyboardEvent>(window, 'keydown').subscribe((event) => {
            const target = event.target as HTMLElement;
            if (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName)) {
                return;
            }
            if (event.key === key) {
                this.demoModeEnabled = !this.demoModeEnabled;
            }
        });
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe(); // Clean up
    }
}
